import { render } from "./IceCreamcone.vue?vue&type=template&id=1980da11"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/IceCreamcone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1980da11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1980da11', __exports__)) {
    api.reload('1980da11', __exports__)
  }
  
  module.hot.accept("./IceCreamcone.vue?vue&type=template&id=1980da11", () => {
    api.rerender('1980da11', render)
  })

}


export default __exports__